import React, { Component } from 'react';

// functions
import { resize } from '../../services/cloudinaryService';

export class DeliveredItem extends Component {
    render() {
        const { detail, product, imageUrl } = this.props.item;
        const itemImage = resize(imageUrl, 125);

        return (
            <li className="u-position-relative">
                <div
                    className="basket__item u-padding-top-small u-padding-bottom-small u-padding-right-small"
                >
                    <div className="image-wrap">
                        <img src={itemImage} alt='' />
                    </div>

                    <div className="description u-padding-left-small">
                        <div className="range">{product}</div>
                        <div className="web-description">{detail}</div>
                    </div>
                </div>

                <div className="basket__value u-padding-small u-padding-top-medium">
                    <div >
                        Delivered
                    </div>
                </div>
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./src/parts/Basket/DeliveredItem.js